export default "__VITE_ASSET__DGGN1TY6__"